import React from 'react';
import PropTypes from 'prop-types';
import './simplePost.scss';

const simplePost = props => {
  const { title, hasAttachment, onClick } = props;
  return (
    <div className="simple-post">
      <div className={'element-box-tp'}>
        <div className="post-box">
          <div className="post-content">
            <div className="post-text">
              <h6 style={{display: 'inline'}}>{title}</h6>
              {
                hasAttachment &&
                <button
                  className="btn btn btn-link btn-sm float-right"
                  type="button"
                  id={'MarketingPostDownload'}
                  style={{display: 'inline'}}
                  onClick={onClick}
                >
                  {'Scarica PDF'}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

simplePost.defaultProps = {
  title: '',
  onClick: () => null,
  hasAttachment: false,
};

simplePost.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  hasAttachment: PropTypes.bool,
};

export default simplePost;
